module.exports = __webpack_public_path__ + "img/background-home.b10c3f77.jpg";